import apiClient from './client.js';
const base = (wsId) => `/workspaces/${wsId}/jobs`;
export const list = (wsId, status) => apiClient.get(base(wsId), { params: status ? { status } : {} }).then(r => r.data);
export const getOne = (wsId, id) => apiClient.get(`${base(wsId)}/${id}`).then(r => r.data);
